import type { TGTMEventObject } from '@/src/general/utils/gtm/types/GTMVariables'

export type TConnectDetails = {
  displayWizardOnSignup?: boolean
  fromIframe?: boolean
  redirectUrl?: string
  /** No redirection if set to true */
  skipRedirect?: boolean
  shouldDismiss?: boolean
  socialName?: string
  locale?: TLocale
  newUser?: boolean
  email?: string
  reload?: boolean
  /**
   * Used instead of redirectUrl:
   * - when the app just reloaded (on social redirection on mobile or on reset password)
   * - or when the app will reload (if reload is set to true)
   */
  reloadUrl?: string
  /** GTM data to be sent before redirecting */
  gtmData?: TGTMEventObject[]
}
